<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-md-6 mb-5">
        <div>
          <step-progress
            :steps="mySteps"
            :current-step="currentStep"
            icon-class="fa fa-check"
            active-color="#c698fa"
          ></step-progress>
        </div>
      </div>
      <div class="col-md-12 ">
        <h3>Select Type:</h3>
        <div
          class=""
          v-if="!loading"
        >
          <b-card-group deck>
            <b-card
              class="text-center"
              :class="{ active: selectType === index }"
              bg-variant="light"
              v-for="(item, index) in productArr"
              :key="index"
              style="max-width: 25%;"
            >
              <b-card-title>{{ index }}</b-card-title>
              <b-card-text></b-card-text>

              <template v-slot:footer>
                <b-button
                  variant="secondary"
                  @click="packageTypeClick(index)"
                >Select</b-button>
              </template>
            </b-card>
          </b-card-group>
        </div>
        <div
          v-else
          class="text-center my-2"
        >
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </div>

      <!-- Children Duration -->

      <div
        class="col-md-12 mt-4 package_duration"
        v-if="selectType == index"
        v-for="(item, index) in productArr"
        :key="index"
      >
        <h3>Select Product:</h3>
        <div class="">
          <b-card-group deck>
            <b-card
              class="text-center"
              :class="{
                active: selectID === productArr[index][childindex].id,
              }"
              bg-variant="light"
              v-for="(childitem, childindex) in productArr[index]"
              :key="childindex"
              style="max-width: 25%;"
            >
              <b-card-title>{{
                productArr[index][childindex].name
              }}</b-card-title>
              <b-card-text></b-card-text>

              <template v-slot:footer>
                <b-button
                  class="btn btn-sm"
                  variant="secondary"
                  @click="packageIDClick(productArr[index][childindex].id)"
                >Select</b-button>
              </template>
            </b-card>
          </b-card-group>
        </div>
      </div>

      <!-- End of Children Duration -->
    </div>
    <div
      class="mt-4 d-flex justify-content-center"
      v-if="selectType != null && selectID != null"
    >
      <b-button
        size="lg"
        block
        variant="primary"
        @click.prevent="PackageSubmit"
      >Next</b-button>
    </div>
  </div>
</template>
<script>
import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";
export default {
  data() {
    return {
      mySteps: ["Product", "Payment"],
      currentStep: 0,
      selectType: null,
      selectID: null,
      productArr: {},
      loading: true
    };
  },
  components: {
    "step-progress": StepProgress
  },
  computed: {},
  mounted() {
    this.loadProduct();
  },
  methods: {
    async loadProduct() {
      this.loading = true;
      await axios
        .get("/api/products/list")
        .then(response => {
          //console.log("len " + response.data.data.length);
          //console.log(response.data);

          for (const key in response.data) {
            let item = response.data[key];
            //console.log(item.id);
            if (this.productArr[item.type] == null) {
              this.productArr[item.type] = {};
            }
            if (this.productArr[item.type][item.id] == null) {
              this.productArr[item.type][item.id] = {};
            }

            this.productArr[item.type][item.id] = item;
            //console.log(Key + " " + response.data[key]);
          }
          //console.log(this.productArr);
        })
        .catch(function(error) {
          //console.log(error.response.data.errors);
          //if(error.response.data.errors.message =)
        })
        .finally(() => (this.loading = false));
    },
    packageTypeClick(type) {
      this.selectType = type;

      this.selectID = null;
    },
    packageIDClick(id) {
      this.selectID = id;
    },
    PackageSubmit() {
      /* this.$store.dispatch("setSaleProductPackage", {
        id: this.selectID,
        type: this.selectType,
        duration: this.selectDuration,
        price: this.
      }); */
      this.$store.dispatch(
        "setSaleProductPackage",
        this.productArr[this.selectType][this.selectID]
      );

      this.$store.dispatch("setSaleProductState", 1);
    }
  }
};
</script>
<style scoped>
.active {
  background-color: #c698fa !important;
}
.package_duration .card-title {
  font-size: 1.1rem;
}
</style>
